import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const API_KEY = import.meta.env.VITE_MOCK_API_KEY;
axios.defaults.baseURL = "https://" + API_KEY + ".mockapi.io";

export const fetchUsers = createAsyncThunk("users/fetchAll",
async (_, thunkAPI) => {
    try {
      const response = await axios.get("/users");
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);